module.exports = __webpack_public_path__ + "img/torre.e724b032.jpg";